import { render, staticRenderFns } from "./Informacion.vue?vue&type=template&id=9495e4d8"
import script from "./Informacion.vue?vue&type=script&lang=js"
export * from "./Informacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9495e4d8')) {
      api.createRecord('9495e4d8', component.options)
    } else {
      api.reload('9495e4d8', component.options)
    }
    module.hot.accept("./Informacion.vue?vue&type=template&id=9495e4d8", function () {
      api.rerender('9495e4d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/perfil/Informacion.vue"
export default component.exports